import { render, staticRenderFns } from "./ProductCombos.vue?vue&type=template&id=328f224f&"
import script from "./ProductCombos.vue?vue&type=script&lang=ts&"
export * from "./ProductCombos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports